import { EventTable } from "./EventTable";
import { SearchBar } from "../Filters";
import { InputField } from "./AddEventForm";
import React, { useState, useEffect, useContext } from "react";
import { eventsAPI, emailAPI, categoriesAPI } from "../../lib/apiService";
import { APIRequestContext } from "../../context";
import { useParams } from "react-router-dom";

function Event() {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const { request_handler } = useContext(APIRequestContext);
  const { category_id } = useParams();

  useEffect(() => {
    // Load categories for the dropdown
    request_handler(async () => {
      const response = await categoriesAPI.getAll();
      setCategories(response.data || response);
      return { data: { message: "Categories loaded successfully" } };
    });
  }, []);

  useEffect(() => {
    // Load events - either all events or events for a specific category
    request_handler(async () => {
      const response = await eventsAPI.getAll();
      let eventsList = response.data || response;
      
      // Map backend field names to frontend expected names
      eventsList = eventsList.map(event => ({
        ...event,
        id: event.event_id, // Map event_id to id
        categoryId: event.categoryId || event.Category?.category_id // Ensure categoryId is available
      }));
      
      // Filter by category if category_id is provided in the route
      if (category_id) {
        eventsList = eventsList.filter(event => event.categoryId == category_id); // Use == for type coercion
      }
      
      setEvents(eventsList);
      return { data: { message: "Events loaded successfully" } };
    });
  }, [category_id]);

  const addEvent = (name, desc, eventDate, location, categoryId) => {
    request_handler(async () => {
      const eventData = {
        name: name,
        description: desc,
        eventDate: eventDate, // Changed from start_date/end_date to eventDate
        location: location || "Kathmandu",
        categoryId: categoryId || category_id, // Use provided categoryId or route param
      };
      
      const response = await eventsAPI.create(eventData);
      const newEvent = response.data || response;
      setEvents([...events, newEvent]);
      
      return { data: { message: "Event added successfully" } };
    });
  };

  const onDelete = (event_id) => {
    console.log(event_id);
    request_handler(async () => {
      await eventsAPI.delete(event_id);
      setEvents(
        events.filter((e) => {
          return e.id !== event_id;
        })
      );
      
      return { data: { message: "Event deleted successfully" } };
    });
  };

  const onEdit = (edited_event, old_event) => {
    request_handler(async () => {
      const response = await eventsAPI.update(old_event.id, edited_event);
      const updatedEvent = response.data || response;
      
      // events that are not edited
      let rest_events = events.filter((e) => {
        return e.id !== old_event.id;
      });
      setEvents([...rest_events, updatedEvent]);
      
      return { data: { message: "Event edited successfully" } };
    });
  };

  const onMailSend = (event_id, send_all) => {
    request_handler(async () => {
      const emailData = {
        send_all: send_all,
        event: event_id,
      };
      
      const response = await emailAPI.sendBulkEmails(emailData);
      return response;
    });
  };

  return (
    <div className="event-wrapper">
      <div className="add-item-form">
        <InputField 
          addEvent={addEvent} 
          categories={categories}
          defaultCategoryId={category_id}
        />
      </div>
      <div className="search-and-sort">
        <SearchBar />
      </div>
      <div className="list-view">
        <EventTable
          events={events}
          categories={categories}
          onDelete={onDelete}
          onEdit={onEdit}
          onMailSend={onMailSend}
        />
      </div>
    </div>
  );
}

export default Event;
